window.IconShapeUI = function () {
	var svgNS = "http://www.w3.org/2000/svg";
	var xlinkNS = "http://www.w3.org/1999/xlink";

	var isLoaded = false;

	var previewElement, previewSvgEl, previewStylesGroupEl, previewIconSvgEl, previewIconEl, previewShapeEl, guid;

	var availableCategories = [
		{ displayName: "Icons", filename: "icon-defs.svg", categoryPrefix: "icon-", tags: [] },
		{ displayName: "Backgrounds", filename: "background-defs.svg", categoryPrefix: "background-", tags: [] },
		{ displayName: "Blocks & Smart visuals", filename: "element-defs.svg", categoryPrefix: "element-", tags: [] },
		{ displayName: "Banners", filename: "banner-defs.svg", categoryPrefix: "banner-", tags: [] },
		{ displayName: "Symbols", filename: "character-defs.svg", categoryPrefix: "character-", tags: [] },
		{ displayName: "Maps - Continents/Countries", filename: "map-defs.svg", categoryPrefix: "map-", tags: [] },
		{ displayName: "Australia", filename: "regionAustralia-defs.svg", categoryPrefix: "regionAustralia-", tags: [] },
		{ displayName: "Canada", filename: "regionCanada-defs.svg", categoryPrefix: "regionCanada-", tags: [] },
		{ displayName: "Germany", filename: "regionGermany-defs.svg", categoryPrefix: "regionGermany-", tags: [] },
		{ displayName: "Netherlands", filename: "regionNetherlands-defs.svg", categoryPrefix: "regionNetherlands-", tags: [] },
		{ displayName: "Sweden", filename: "regionSweden-defs.svg", categoryPrefix: "regionSweden-", tags: [] },
		{ displayName: "UK", filename: "regionUK-defs.svg", categoryPrefix: "regionUK-", tags: [] },
		{ displayName: "USA", filename: "regionUSA-defs.svg", categoryPrefix: "regionUSA-", tags: [] },
		{ displayName: "Flags", filename: "flag-defs.svg", categoryPrefix: "flag-", tags: [], static: true }
	];

	// default settings - will be used in new objects
	var defaultStylesArray = [
		{ styleKey: "use_color", styleValue: "True" },
		{ styleKey: "use_gradient", styleValue: "False" },
		{ styleKey: "color", styleValue: "#4c4c4c" },
		{ styleKey: "gradient_stop_1_offset", styleValue: 0 },
		{ styleKey: "gradient_stop_1_stop-color", styleValue: "#29abe2" },
		{ styleKey: "gradient_stop_2_offset", styleValue: 100 },
		{ styleKey: "gradient_stop_2_stop-color", styleValue: "#22b573" },
		{ styleKey: "gradient_orientation", styleValue: "horizontal" },
		{ styleKey: "polygon_sides", styleValue: 6 },
		{ styleKey: "stroke", styleValue: "#4c4c4c" },
		{ styleKey: "stroke_width", styleValue: 0 },
		{ styleKey: "stroke_style", styleValue: 0 },
		{ styleKey: "radius", styleValue: 10 },
		{ styleKey: "opacity", styleValue: 100 },
		{ styleKey: "invert", styleValue: "False" },
		{ styleKey: "padding", styleValue: 0 },
		{ styleKey: "flip_horizontal", styleValue: "False" },
		{ styleKey: "flip_vertical", styleValue: "False" },
		{ styleKey: "rotate", styleValue: 0 }
	];

	/* Icon/Shape Events Manager */

	var EventsManager = {
		dataKey: "userEvents",

		addEventsToSvgElement: function (svgElement) {
			Storyboard.LayoutDesigner.UserEvents.addEventsToElement(svgElement);
		},

		removeEventsFromSvgElement: function (svgElement) {	
			Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement(svgElement);
		},

		setEventsTabUI: function (layoutElementItem) {
			Storyboard.LayoutDesigner.UserEvents.setEventsTabUI(layoutElementItem, previewSvgEl);
		}
	};

	/* end Icon/Shape Events Manager */


	return {
		defaultPositiveIcon: null,
		defaultNegativeIcon: null,
        defaultFormattingRuleIcon: {
            objectType: 2,
            iconShapeKey: "Circle",
            width: 30,
            height: 30,
            styles: [
				{ styleKey: "use_color", styleValue: "True" },
				{ styleKey: "use_gradient", styleValue: "False" },
				{ styleKey: "gradient_stop_1_offset", styleValue: 0 },
				{ styleKey: "gradient_stop_1_stop-color", styleValue: "#29abe2" },
				{ styleKey: "gradient_stop_2_offset", styleValue: 100 },
				{ styleKey: "gradient_stop_2_stop-color", styleValue: "#22b573" },
				{ styleKey: "gradient_orientation", styleValue: "horizontal" },
				{ styleKey: "polygon_sides", styleValue: 6 },
				{ styleKey: "stroke", styleValue: "#4c4c4c" },
				{ styleKey: "stroke_width", styleValue: 0 },
				{ styleKey: "stroke_style", styleValue: 0 },
				{ styleKey: "radius", styleValue: 10 },
				{ styleKey: "opacity", styleValue: 100 },
				{ styleKey: "invert", styleValue: "False" },
				{ styleKey: "padding", styleValue: 0 },
				{ styleKey: "flip_horizontal", styleValue: "False" },
				{ styleKey: "flip_vertical", styleValue: "False" },
				{ styleKey: "rotate", styleValue: 0 },
                { styleKey: "color", styleValue: "#9bbb58" }
            ],
            content: "<svg id=\"iconPreviewSvg\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100%\" height=\"100%\"><g class=\"group-styles\" fill=\"#9bbb58\"><circle cx=\"15\" cy=\"15\" r=\"15\" class=\"element-shape element-shape-Circle\"></circle></g></svg>"
		},

		addCategory: function (category) {
			availableCategories.push(category);
		},

		getDefaultIcons: function (callback) {
			if (!IconShapeUI.defaultPositiveIcon || !IconShapeUI.defaultNegativeIcon)
				ChartSetupProxy.GetDefaultSigTestIcons(function (icons) {
					IconShapeUI.setupPreview();
					previewElement.css({
						width: 50,
						height: 50
					});

					IconShapeUI.resetSelections();
					IconShapeUI.defaultPositiveIcon = icons[0];
					IconShapeSetup.bindIconShapeSettings(IconShapeUI.defaultPositiveIcon);
					IconShapeUI.defaultPositiveIcon.content = IconShapeUI.getPreviewSvg();

					IconShapeUI.resetSelections();
					IconShapeUI.defaultNegativeIcon = icons[1];
					IconShapeSetup.bindIconShapeSettings(IconShapeUI.defaultNegativeIcon);
					IconShapeUI.defaultNegativeIcon.content = IconShapeUI.getPreviewSvg();

					if (callback)
						callback();
				});
		},

		EventsManager: EventsManager,

		resetSelections: function () {
			// clear some settings
			$("#hidIconShapeId").val(0);
			$("#hidIconShapeKey").val("");
			$("#txtZoneIconShapeName").val("");
			$("#IconShapeTitle, #IconShapeTags").empty();
			$("#is_library .iconControl, #is_library .shapeControl").hide();
			// clear selection
			if ($("#is_library .iconSelect.selected").length > 0)
				$("#is_library .iconSelect.selected").get(0).setAttribute("class", "iconSelect");
		},

		resetIconFilters: function () {
			$("#ddliconFilterCategories").val(availableCategories[0].categoryPrefix);
			$("#txtIconSearch").val("");
			IconShapeUI.filterIcons();
		},

		setupPreview: function (elementItem) {
			if (!isLoaded) {
				this.setupIconsAndShapesSelectors();
				this.bindPreviewEvents();
				isLoaded = true;
			}

			previewElement = $("#iconPreviewDiv");
			previewSvgEl = document.getElementById("iconPreviewSvg");

			if (elementItem) {
				$("#" + elementItem.guid).empty();
				guid = elementItem.guid;
				this.clearPreview();

				previewElement.css({
					width: elementItem.width,
					height: elementItem.height
				});
				$("#setupIconShapeTab #panels").css('min-height', $('#setupIconShapeTab .preview-groupings').height() || 560);
			} else {
				guid = Helpers.generateGuid();
			}

		},

		getPreviewSvg: function (svgElement) {
			if (!svgElement) svgElement = previewSvgEl;
			
			var events = Storyboard.LayoutDesigner.UserEvents.getEventsOptions(svgElement);
			var newSvgElement = svgElement.cloneNode(true);
			
			if (newSvgElement) newSvgElement.removeAttribute("id");
			if (events) $(newSvgElement).attr('data-user-events', events);

			// using a "replace" to deal with IE adding extra quotes in url() attrs
			return $(newSvgElement).wrap('<div>').parent().html();
		},

		getDefaultStyles: function () {
			return defaultStylesArray;
		},

		getCategoryByPrefix: function(prefix) {
			for (var p in availableCategories)
				if (availableCategories.hasOwnProperty(p)) {
					if (availableCategories[p].categoryPrefix == prefix)
						return availableCategories[p];
				}
			return null;
		},

		onObjectTypeChanged: function () {
			var objectType = $("#ddliconFilterCategories").val();
			
			IconShapeUI.showHideLibraryControls();

			if (objectType !== "shape") 
				IconShapeUI.filterIcons();
		},

		onShapeChanged: function (selectedShapeType) {
			$(".iconPadding, .iconInvert, .iconShapeFlip, .shapePolygon").hide();
			$(".shapeBorder").show();

			$("#iconShapeSettingsLayoutTabLabel").text("Shape");
			
			$(".iconShapeBackground").toggle(selectedShapeType !== "Line");
			$(".shapeRadius").toggle(selectedShapeType === "Rounded");
			$(".shapePolygon").toggle(selectedShapeType === "Polygon");

			// Remove 0 option for Line shape
			if (selectedShapeType === "Line") {
				$(".shapeBorder > h3").text(locale.get("Line"));
				if ($("#si_style_stroke_width").val() === "0") {
					$("#si_style_stroke_width").val("1");
				}
				$("#si_style_stroke_width option[value='0']").remove();
			} else {
				$(".shapeBorder > h3").text(locale.get("Border"));
				if ($("#si_style_stroke_width option[value='0']").length === 0) {
					$("#si_style_stroke_width").prepend("<option value='0'>0</option>");
					if ($("#si_style_stroke_width").val() === "1") {
						$("#si_style_stroke_width").val("0");
					}
				}
			}
		},

		onIconChanged: function(selectedCategoryPrefix) {
			var category = IconShapeUI.getCategoryByPrefix(selectedCategoryPrefix);
			$(".shapeBorder, .shapePolygon").hide();
			$(".iconPadding, .iconInvert, .iconShapeFlip").show();

			$(".iconShapeBackground").show();
			$(".iconShapeBackground, .iconShapeFlip").toggle(!category.static);
			$("#chkLayoutElementStyleColorEvent, #chkLayoutElementStylePaddingEvent")
				.closest('.settingItem').toggle(!category.static);

			if (category)
				$("#iconShapeSettingsLayoutTabLabel").text(category.displayName);
		},

		onIconArrowKeydown: function(e) {
			var selectedSvgEl = $("#is_library .iconSelect.selected");
			var objectType = parseInt($("#hidIconShapeType").val(), 10);
			var selectedSvgElOffset = selectedSvgEl.offset();
			var nextSvgEl;

			if (selectedSvgEl.length === 0) return;

			switch (e.keyCode) {
				case 37:
					nextSvgEl = selectedSvgEl.prev('.iconSelect');
					// left arrow key
					break;
				case 38:
					nextSvgEl = $(selectedSvgEl)
						.prevAll()
						.filter(function() {
							var offset = $(this).offset();
							return offset.left === selectedSvgElOffset.left;
						}).first();
					// up arrow key
					break;
				case 39:
					nextSvgEl = selectedSvgEl.next('.iconSelect');
					// right arrow key
					break;
				case 40:
					nextSvgEl = $(selectedSvgEl)
						.nextAll()
						.filter(function() {
							var offset = $(this).offset();
							return offset.left === selectedSvgElOffset.left;
						}).first();
					// bottom arrow key
					break;
				default:
					return false;
			}

			if (nextSvgEl && nextSvgEl.length === 1) {
				var iconEl = nextSvgEl.get(0);
				
				if (objectType === 1) {
					var iconId = iconEl.firstElementChild.getAttributeNS(xlinkNS, "href").substr(1);
					IconShapeUI.setSelectedIcon(iconId, iconEl);
					IconShapeUI.scrollToIconTop(iconEl);
				}
				else if (objectType === 2) {
					var shapeType = iconEl.firstElementChild.getAttributeNS(xlinkNS, "href").substr(6);
					IconShapeUI.setSelectedShape(shapeType, iconEl);
				}
				IconShapeUI.updatePreview();
			}
			
		},

		// shows/hides Icon/Shape selection controls based on selected object type
		showHideLibraryControls: function() {
			$("#is_library .iconControl").toggle($("#ddliconFilterCategories").val() !== "shape");
			$("#is_library .shapeControl").toggle($("#ddliconFilterCategories").val() === "shape");
		},

		// loads available icons from .svg file into icon selector box
		setupIconsAndShapesSelectors: function () {
			var tooltip;
			
			$("#ddliconFilterCategories").empty();

			$(availableCategories).each(function (index) {
				if (this.categoryPrefix.substr(0,6) === "region") {
					if ($("#ddliconFilterCategories optgroup.region").length > 0) {
						$("#ddliconFilterCategories optgroup.region")
							.append("<option value='" + this.categoryPrefix + "'>" + this.displayName + "</option>");
					} else {
						$("#ddliconFilterCategories")
							.append("<optgroup label='Maps - States/Regions/Provinces' class='region'><option value='" + this.categoryPrefix + "'>" + this.displayName + "</option</optgroup>");
					}

				} else {
					$("#ddliconFilterCategories").append("<option value='" + this.categoryPrefix + "'>" + this.displayName + "</option>");
				}
				
				// Load default Icons category
				if (index === 0) IconShapeUI.loadIcons(this);
			});

			$("#ddliconFilterCategories > option:first-child").after('<option value="shape">Shapes</option>');

			$("#shapesSelector .iconSelect").unbind("click").bind("click", function () {
				var shapeType = this.firstElementChild.getAttributeNS(xlinkNS, "href").substr(6);
				IconShapeUI.setSelectedShape(shapeType, this);
				IconShapeUI.updatePreview();
			});

			$("#iconsSelector").undelegate(".iconSelect", "click").delegate(".iconSelect", "click", function() {
				var iconId = this.firstElementChild.getAttributeNS(xlinkNS, "href").substr(1);
				IconShapeUI.setSelectedIcon(iconId, this);
				IconShapeUI.updatePreview();
			});

			$("#iconsSelector, #shapesSelector").unbind("keydown").bind("keydown", function(e) {
				if ((e.keyCode >= 37 && e.keyCode <= 40 || e.which >= 37 &&
					e.which <= 40 || e.keyCode === 9 || e.which === 9)) {
						e.preventDefault();
				}
				
				clearTimeout(tooltip);
				$('#iconsSelector .DUITooltipInfo').remove();
				IconShapeUI.onIconArrowKeydown(e);
			});

			$("#iconsSelector").undelegate(".iconSelect", "mouseenter")
				.delegate(".iconSelect", "mouseenter", function (e) {
					var that = this;

					tooltip = setTimeout(function () {
						var use = that.firstChild;
						var iconId = use.getAttributeNS(xlinkNS, "href").substr(1);
						var iconInfo = IconShapeUI.getIconInfo(iconId);

						if (iconInfo.title === "" && iconInfo.tags === "") return;

						var keyword = $("#txtIconSearch").val().toLowerCase();
						var iconSelectorSize = $("#iconSelectorSizeSlider").slider("value");
						var left = (e.clientX + iconSelectorSize + 20) + "px";
						var top = (e.clientY - iconSelectorSize) + "px";
						var iconTags = iconInfo.tags;

						if (keyword !== "" && keyword.indexOf(" ") === -1) {
							keyword = keyword.replace(/s\b/g, "").replace(/\s+/g, " ");
							var pattern = new RegExp("[^,]*"+ keyword + "[^,]*", "gi");
							var replaceWith = "<mark>$&</mark>";
							iconTags = iconInfo.tags.replace(pattern, replaceWith);
						}
						
						$("<div/>", {
							html: "<b>" + iconInfo.title + "</b>" + "<br>" + iconTags,
							"class": "DUITooltipInfo",
							css: {
								"left": left,
								"top":  top
							}
						}).insertAfter(that);
					}, 400);
				}).undelegate(".iconSelect", "mouseleave").delegate(".iconSelect", "mouseleave", function () {
					clearTimeout(tooltip);
					$('#iconsSelector .DUITooltipInfo').remove();
				});

			$("#IconShapeTagsList").undelegate('span', 'click').delegate('span', 'click', function() {
				$("#txtIconSearch").val($(this).text());
				IconShapeUI.filterIcons();
			});
		},

		loadIcons: function(category) {
			var iconSelector = document.getElementById("iconsSelector");
			var loadingBar = Storyboard.LayoutControls.showLoadingBar("Loading " + category.displayName);
			Storyboard.Dependency.start(['CHARTSETUP', 'SIMPLETABLESETUP', 'ICONSHAPESETUP'], 'icons');

			var ajax = new XMLHttpRequest();
			ajax.open("GET", "icons/" + category.filename, true);
			ajax.send();

			category.loaded = false;

			ajax.onload = function() {
				var icons = document.createDocumentFragment();

				iconSelector.innerHTML = iconSelector.innerHTML.replace(/NS\d+:href/gi, 'xlink:href') + ajax.responseText;
				var svgSymbols = iconSelector.getElementsByTagName("symbol");

				for (var i = 0; i < svgSymbols.length; i++) {
					if (svgSymbols[i].getAttribute("class") === "iconsLoaded")
						continue;

					svgSymbols[i].setAttribute("class", "iconsLoaded");
					var svgUse = document.createElementNS(svgNS, "svg");
					var use = document.createElementNS(svgNS, "use");
					var viewBox = svgSymbols[i].getAttribute("viewBox");
					var tags = svgSymbols[i].querySelector("desc");
					var id = svgSymbols[i].id;

					if (tags && tags.textContent !== "") 
						category.tags = category.tags.concat(tags.textContent.split(", "));

					svgUse.setAttribute("viewBox", viewBox);
					svgUse.setAttribute("class", "iconSelect");
					svgUse.setAttribute("iconId", id);

					use.setAttributeNS(xlinkNS, "href", "#" + id);

					svgUse.appendChild(use);
					icons.appendChild(svgUse);
				}

				iconSelector.appendChild(icons);
				IconShapeUI.sortTags(category);
				category.loaded = true;

				IconShapeUI.filterIcons();
				Storyboard.LayoutControls.hideLoadingBar(loadingBar);
				Storyboard.Dependency.complete(['CHARTSETUP', 'SIMPLETABLESETUP', 'ICONSHAPESETUP'], 'icons');

				var iconShapeKey = $("#hidIconShapeKey").val();

				if ($(previewSvgEl).is(":empty") && $("#ddliconFilterCategories").val() !== "shape" && iconShapeKey !== "") {
					IconShapeUI.setSelectedIcon(iconShapeKey);
					IconShapeUI.updatePreview();
				}
			};

			ajax.onerror = function (e) {
				delete category.loaded;
				Storyboard.LayoutControls.hideLoadingBar(loadingBar);
			};
		},

		sortTags: function(category) {
			category.tags.sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});

			category.tags = category.tags.filter(function(value, index, arr){
				if(index < 1) 
					return true;
				else
					return value != arr[index-1];
			});
		},

		bindPreviewEvents: function () {

			$("#ddliconFilterCategories").bind("change", IconShapeUI.onObjectTypeChanged);
			$("#btnUpdateZoneIconShape").bind("click", IconShapeSetup.saveLibraryIconSetup);

			// initialize sliders
			$("#iconSelectorSizeSlider").slider({
				value: 24,
				min: 16,
				max: 56,
				step: 4,
				slide: function (event, ui) {
					$("#iconsSelector").css("font-size", ui.value + "px");
				}
			});

			// filter icons by keywords
			$("#txtIconSearch").bind("keyup", function () { IconShapeUI.filterIcons(); });

			// initialize colorpickers
			$('#is_layout .ColorTextbox').DUIColorPicker({layout: 'template'});

			// single color mode
			var colorHandler = function (evt) {
				if ($("#si_style_use_color").is(":checked")) {
					var colorObject = IconShapeUI.getColorObject();
					var gradient =  previewSvgEl.querySelector("linearGradient") || 
									previewSvgEl.querySelector("radialGradient");
					if (gradient) gradient.parentNode.removeChild(gradient);
					
					IconShapeUI.setColor(colorObject, previewStylesGroupEl);
				}
			};
			$("#si_style_use_color").bind("change", colorHandler);
			$("#si_style_color").bind("colorChange.DUIColorPicker", colorHandler);

			// gradient mode
			var gradientHandler = function () {
				if ($("#si_style_use_gradient").is(":checked")) {
					var gradientObject = IconShapeUI.getGradientObject();
					IconShapeUI.setGradient(gradientObject, previewStylesGroupEl, previewSvgEl, guid);
				}
			};
			$("#si_style_use_gradient").bind("change", gradientHandler);
			$("#si_style_gradient_orientation").bind("change", gradientHandler);
			$("#si_style_gradient_stop_1_stop-color").bind("colorChange.DUIColorPicker", gradientHandler);
			$("#si_style_gradient_stop_2_stop-color").bind("colorChange.DUIColorPicker", gradientHandler);
			$("#si_style_gradient_stop_1_offset, #si_style_gradient_stop_2_offset").bind("blur", gradientHandler);

			$("#is_layout .iconColorSettings input:radio").bind("change", function() {
				$("#is_layout .iconColorSettings .settingControl").css('visibility', 'hidden');
				$(this).closest(".iconColorSettings").find(".settingControl").css('visibility', '');
			});

			// invert
			$("#si_style_invert").bind("change", function () {
				IconShapeUI.setInvert($(this).is(":checked"), previewIconSvgEl, previewStylesGroupEl, previewSvgEl, guid);
			});

			// flip
			$("#si_style_flip_horizontal, #si_style_flip_vertical").bind("change", function () {
				var flipArray = IconShapeUI.getFlipArray();
				IconShapeUI.setFlip(flipArray, previewIconSvgEl);
			});

			Helpers.setupNumericTextbox($("#si_style_padding"));
			Helpers.setupNumericTextbox($("#si_style_opacity"));
			Helpers.setupNumericTextbox($("#si_style_rotate"));

			// padding
			$("#si_style_padding").bind("change", function (evt) {
				var padding = parseInt($(this).val(), 10);

				padding = (isNaN(padding) ? 0 : Math.max(0, Math.min(49, padding)));
				IconShapeUI.setPadding(padding, previewElement);
				$(this).val(padding + "%");
			});

			// opacity
			$("#si_style_opacity").bind("change", function () {
				var opacity = parseInt($(this).val(), 10);

				opacity = (isNaN(opacity) ? 100 : Math.max(0, Math.min(100, opacity)));
				IconShapeUI.setOpacity(opacity, previewStylesGroupEl);
				$(this).val(opacity);
			});

			// rotate
			$("#si_style_rotate").bind("change", function () {
				var rotate = parseInt($(this).val(), 10);

				rotate = (isNaN(rotate) ? 0 : Math.max(-360, Math.min(360, rotate)));
				IconShapeUI.setRotate(rotate, previewElement);
				$(this).val(rotate + "°");
			});

			// Shape border
			$("#si_style_stroke").bind("colorChange.DUIColorPicker", function (evt) {
				var selectedShapeType = $("#hidIconShapeKey").val();
				var strokeObject = IconShapeUI.getStrokeObject();
				
				if ($("#si_style_stroke_width").val() != 0 || selectedShapeType === "Line")
					IconShapeUI.setStroke(strokeObject, previewShapeEl);
			});
			$("#si_style_stroke_width").bind("change", function () {
				var selectedShapeType = $("#hidIconShapeKey").val();
				var strokeWidth = parseInt($(this).val(), 10);
				var polygonSides = IconShapeUI.getPolygonSides();
				var shapeSize = IconShapeUI.calculateShapeSize(previewElement, selectedShapeType, strokeWidth, polygonSides);
				if (strokeWidth && (strokeWidth > 0 || selectedShapeType === "Line")) {
					shapeSize["stroke-width"] = strokeWidth;
				} else {
					previewShapeEl.removeAttribute("stroke");
					previewShapeEl.removeAttribute("stroke-width");
					previewShapeEl.removeAttribute("stroke-dasharray");
				}
				IconShapeUI.setShapeAttributes(previewShapeEl, shapeSize);
				IconShapeUI.updatePreview();
			});
			$("#si_style_radius").bind("change", function () {
				IconShapeUI.setRadius($(this).val(), previewShapeEl);
			});
			$("#si_style_stroke_style").bind("change", function () {
				IconShapeUI.setStrokeDashArray($(this).val(), previewShapeEl);
			});
			$("#si_style_polygon_sides").bind("change", function () {
				var selectedShapeType = "Polygon";
				var strokeWidth = IconShapeUI.getStrokeWidth();
				var polygonSidesInput = parseInt($(this).val(), 10);
				var polygonSides = polygonSidesInput < 5 ? 6 : polygonSidesInput; 
				var shapeSize = IconShapeUI.calculateShapeSize(previewElement, selectedShapeType, strokeWidth, polygonSides);
				IconShapeUI.setShapeAttributes(previewShapeEl, shapeSize);
				IconShapeUI.updatePreview();
			});
		},

		updatePreview: function () {
			if ($(previewSvgEl).is(':empty')) return;

			var flipArray, gradientObject, 
			colorObject, strokeObject,
			$useColor = $("#si_style_use_color"),
			$useGradient = $("#si_style_use_gradient"),
			$strokeWidth = $("#si_style_stroke_width"),
			$strokeStyle = $("#si_style_stroke_style"),
			$radius = $("#si_style_radius"),
			$padding = $("#si_style_padding"),
			$invert = $("#si_style_invert"),
			$opacity = $("#si_style_opacity"),
			$rotate = $("#si_style_rotate");

			var selectedShapeType = $("#hidIconShapeKey").val();
			var selectedCategory = $("#ddliconFilterCategories").val();
			var category = IconShapeUI.getCategoryByPrefix(selectedCategory);
			var isStatic = category && category.static;

			if (previewStylesGroupEl && 
				((selectedCategory === "shape" && selectedShapeType === "Line") || isStatic)) {
					previewStylesGroupEl.removeAttribute("fill");
			}

			if (!isStatic) {
				// Color
				if (previewStylesGroupEl && $useColor.is(":checked")) {
					colorObject = this.getColorObject();
					this.setColor(colorObject, previewStylesGroupEl);
				}
					

				// Gradient
				if (previewStylesGroupEl && $useGradient.is(":checked")) {
					gradientObject = this.getGradientObject();
					this.setGradient(gradientObject, previewStylesGroupEl, previewSvgEl, guid);
				} else {
					var defs = previewSvgEl.querySelector("defs");
					if (defs) defs.parentNode.removeChild(defs);
				}

				if (previewIconEl && previewStylesGroupEl) {
					// Icon Flip
					flipArray = this.getFlipArray();
					this.setFlip(flipArray, previewIconSvgEl);

					// Icon Padding
					this.setPadding($padding.val(), previewElement);

					// Icon Invert
					this.setInvert($invert.is(":checked"), previewIconSvgEl, previewStylesGroupEl, previewSvgEl, guid);
				}
			}

			if (previewShapeEl) {
				// Shapes Stroke Styles
				if ($strokeWidth.val() != 0 || selectedShapeType === "Line") {
					strokeObject = this.getStrokeObject();
					this.setStroke(strokeObject, previewShapeEl);
					if ($strokeStyle.val() != 0)
						this.setStrokeDashArray($strokeStyle.val(), previewShapeEl);
				}

				// Rounded Rectangle Border Radius
				if (selectedShapeType === "Rounded") {
					this.setRadius($radius.val(), previewShapeEl);
				}
			}

			if (previewStylesGroupEl) {
				// Opacity
				this.setOpacity($opacity.val(), previewStylesGroupEl);

				// Rotate
				this.setRotate($rotate.val(), previewElement);
			}

			IconShapeUI.EventsManager.addEventsToSvgElement(previewSvgEl);
		},

		updateElementOpacity: function(elementItemGuid, opacity) {
			var elementItem = Storyboard.LayoutDesigner.getElementItemByGuid(elementItemGuid);
			var iconShapeElement = document.getElementById(elementItemGuid);
			var stylesGroupEl = iconShapeElement.querySelector("g.group-styles");
			var settings = Storyboard.IconShapeCache.getIconShapeSettingsFromCache(elementItemGuid);
			var newOpacity;

			if (stylesGroupEl && settings && IconShapeSetup.getStyleByKey("opacity", settings.styles) != opacity) {
				newOpacity = IconShapeUI.setOpacity(opacity, stylesGroupEl);
				$("#DUI-ST-CM-OPACITY").val(newOpacity);
				settings.content = IconShapeUI.getPreviewSvg(iconShapeElement.querySelector("svg"));
				IconShapeSetup.setStyleByKey("opacity", newOpacity, settings.styles);
				IconShapeSetup.saveContextMenu(elementItem, settings);
			}
		},

		updateElementColor: function(elementItemGuid, colorObject) {
			var elementItem = Storyboard.LayoutDesigner.getElementItemByGuid(elementItemGuid);
			var iconShapeElement = document.getElementById(elementItemGuid);
			var stylesGroupEl = iconShapeElement.querySelector("g.group-styles");
			var settings = Storyboard.IconShapeCache.getIconShapeSettingsFromCache(elementItemGuid);

			if (stylesGroupEl && settings) {
				if (settings.iconShapeKey && settings.iconShapeKey === "Line") {
					IconShapeUI.setStroke(colorObject, stylesGroupEl.querySelector("line"));
					settings.content = IconShapeUI.getPreviewSvg(iconShapeElement.querySelector("svg"));
					IconShapeSetup.setStyleByKey("stroke", colorObject.color, settings.styles);
					IconShapeSetup.setStyleByKey("stroke_colorPlaceholderId", colorObject.colorId || '', settings.styles);
					IconShapeSetup.saveContextMenu(elementItem, settings);
				} else {
					IconShapeUI.setColor(colorObject, stylesGroupEl);
					settings.content = IconShapeUI.getPreviewSvg(iconShapeElement.querySelector("svg"));
					IconShapeSetup.setStyleByKey("color", colorObject.color, settings.styles);
					IconShapeSetup.setStyleByKey("color_colorPlaceholderId", colorObject.colorId || '', settings.styles);
					IconShapeSetup.saveContextMenu(elementItem, settings);
				}
			}
		},

		updateElementGradientColors: function(elementItemGuid, color1Object, color2Object) {
			var elementItem = Storyboard.LayoutDesigner.getElementItemByGuid(elementItemGuid);
			var iconShapeElement = document.getElementById(elementItemGuid);
			var stop1 = iconShapeElement.querySelector("defs stop:first-child");
			var stop2 = iconShapeElement.querySelector("defs stop:last-child");
			var settings = Storyboard.IconShapeCache.getIconShapeSettingsFromCache(elementItemGuid);

			if (stop1 && stop2 && settings) {
				if (color1Object.color.indexOf("transparent") > -1 || color1Object.color.replace(/ /g, "").indexOf("(255,255,255,0") > -1) {
					stop1.setAttribute("stop-opacity", 0);
					color1Object.color = "white";
				}
				if (color2Object.color.indexOf("transparent") > -1 || color2Object.color.replace(/ /g, "").indexOf("(255,255,255,0") > -1) {
					stop2.setAttribute("stop-opacity", 0);
					color2Object.color = "white";
				}
				stop1.setAttribute("stop-color", color1Object.color);
				stop2.setAttribute("stop-color", color2Object.color);

				if (color1Object.colorId)
					stop1.setAttribute("data-stop-color-colorplaceholderid", color1Object.colorId);
				else
					stop1.removeAttribute("data-stop-color-colorplaceholderid");

				if (color2Object.colorId)
					stop2.setAttribute("data-stop-color-colorplaceholderid", color2Object.colorId);
				else
					stop2.removeAttribute("data-stop-color-colorplaceholderid");

				settings.content = IconShapeUI.getPreviewSvg(iconShapeElement.querySelector("svg"));
				IconShapeSetup.setStyleByKey("gradient_stop_1_stop-color", color1Object.color, settings.styles);
				IconShapeSetup.setStyleByKey("gradient_stop_2_stop-color", color2Object.color, settings.styles);
				IconShapeSetup.setStyleByKey("gradient_stop_1_stop-color_colorPlaceholderId", color1Object.colorId || '', settings.styles);
				IconShapeSetup.setStyleByKey("gradient_stop_2_stop-color_colorPlaceholderId", color2Object.colorId || '', settings.styles);

				IconShapeSetup.saveContextMenu(elementItem, settings);
			}
		},

		updateElementFlip: function(elementItemGuid, direction) {
			var elementItem = Storyboard.LayoutDesigner.getElementItemByGuid(elementItemGuid);
			var iconShapeElement = document.getElementById(elementItemGuid);
			var iconSvgEl = iconShapeElement.querySelector("svg svg");
			var settings = Storyboard.IconShapeCache.getIconShapeSettingsFromCache(elementItemGuid);

			if (iconSvgEl && settings) {
				var flipArray = [];

				flipArray[0] = (IconShapeSetup.getStyleByKey("flip_horizontal", settings.styles) === "True" ? true : false);
				flipArray[1] = (IconShapeSetup.getStyleByKey("flip_vertical", settings.styles) === "True" ? true : false);

				if (direction === "horizontal") flipArray[0] = !flipArray[0];
				if (direction === "vertical")   flipArray[1] = !flipArray[1];

				IconShapeUI.setFlip(flipArray, iconSvgEl);
				settings.content = IconShapeUI.getPreviewSvg(iconShapeElement.querySelector("svg"));
				IconShapeSetup.setStyleByKey("flip_horizontal", (flipArray[0] === true ? "True" : "False"), settings.styles);
				IconShapeSetup.setStyleByKey("flip_vertical", (flipArray[1] === true ? "True" : "False"), settings.styles);
				IconShapeSetup.saveContextMenu(elementItem, settings);
			}
		},

		updateIconShapeElementSize: function(elementItem, containerElement) {
			containerElement = containerElement || $("#" + elementItem.guid);
			var svgElement = containerElement[0].querySelector("svg");
			var groupStylesElement, groupRotationElement, stroke, elementShape, shapeClass, shapeType, polygonSides;

			if (svgElement) {
				groupStylesElement 		= svgElement.querySelector("g.group-styles");
				groupRotationElement	= svgElement.querySelector("g.group-rotation");
				elementShape 			= svgElement.querySelector(".element-shape");

				if (groupStylesElement === null) return;

				if (elementShape) {
					// Read shape type
					shapeClass = elementShape.getAttribute("class");
					shapeType = shapeClass.split("-shape-")[1];

					if (typeof IconShapeUI["render" + shapeType] === "function") {
						if (shapeType === "Polygon") 
							polygonSides = elementShape.getAttribute("points").split(",").length - 1;
						// Update shape element size
						stroke = elementShape.getAttribute("stroke-width") || 0;
						var newShapeSize = IconShapeUI.calculateShapeSize(containerElement, shapeType, stroke, polygonSides);
						IconShapeUI.setShapeAttributes(elementShape, newShapeSize);
						if (elementItem) elementItem.content = IconShapeUI.getPreviewSvg(svgElement);
					}
				}

				// Update rotation
				var transform = (groupRotationElement ? groupRotationElement.getAttribute('transform') :
														groupStylesElement.getAttribute('transform'));
				if (transform && transform.indexOf('rotate(') > -1) {
					var rotation = parseInt(transform.split('rotate(')[1].split(')')[0].split(','), 10);
					if (!isNaN(rotation)) {
						IconShapeUI.setRotate(rotation, containerElement);
						if (elementItem) elementItem.content = IconShapeUI.getPreviewSvg(svgElement);
					}
				}
			}
		},

		fixGUIDs: function(content, guid) {
			if (content && (content.indexOf("gradient") > -1 || content.indexOf("mask") > -1)) {
				guid = guid || Helpers.generateGuid();
				content = content.replace(/\b[a-f\d-]{36}\b/g, guid);
				content = content.replace(/\b[a-f\d]{32}\b/g, guid);
				content = content.replace(/gradient-guid/g, "gradient-" + guid);
			}
			return content;
		},

		setSelectedShape: function (shapeType, iconContainer) {
			IconShapeUI.onShapeChanged(shapeType);
			// clear selection
			if ($("#is_library .iconSelect.selected").length > 0)
				$("#is_library .iconSelect.selected").get(0).setAttribute("class", "iconSelect");

			// find shape (when iconShape settings control is opened we need to select correct one)
			if (!iconContainer) {
				$("#ddliconFilterCategories").val("shape").trigger("change");

				var iconSvgs = document.getElementById("shapesSelector").getElementsByClassName("iconSelect");
				for (var i = 0; i < iconSvgs.length; i++) {
					var use = iconSvgs[i].firstElementChild;
					if (use.getAttributeNS(xlinkNS, "href").substr(6) == shapeType) {
						iconContainer = iconSvgs[i];
						break;
					}
				}
			}

			if (iconContainer)
				iconContainer.setAttribute("class", "iconSelect selected");

			$("#hidIconShapeType").val(2);
			$("#hidIconShapeKey").val(shapeType);
			$("#IconShapeTitle, #IconShapeTags").empty();
			IconShapeUI.setShape(shapeType);
		},

		setShape: function (shapeType, iconShapeElement) {
			iconShapeElement = iconShapeElement || previewElement;
			var shapeRenderFunction = "render" + shapeType;
			var groupStylesElement = document.createElementNS(svgNS, "g");
			var shapeElement, strokeWidth, polygonSides, shapeSize;

			if (typeof this[shapeRenderFunction] === "function") {
				strokeWidth = this.getStrokeWidth();
				polygonSides = this.getPolygonSides();
				shapeSize = this.calculateShapeSize(iconShapeElement, shapeType, strokeWidth, polygonSides);
				if (strokeWidth > 0) {
					shapeSize["stroke-width"] = strokeWidth;
					shapeSize["vector-effect"] = "non-scaling-stroke";
				}

				this.clearPreview();

				shapeElement = this[shapeRenderFunction](shapeSize);
				shapeElement.setAttribute("class", "element-shape element-shape-" + shapeType);
				groupStylesElement.setAttribute("class", "group-styles");
				groupStylesElement.appendChild(shapeElement);
				previewSvgEl.appendChild(groupStylesElement);
				previewStylesGroupEl = groupStylesElement;
				previewShapeEl = shapeElement;
			}
		},

		calculateShapeSize: function (iconShapeElement, shapeType, stroke, polygonSides) {
			iconShapeElement = iconShapeElement || previewElement;
			var shapeSize;
			var radius;
			var sides;
			var iconShapeHeight = iconShapeElement.height() || parseInt(iconShapeElement[0].style.height, 10),
				iconShapeWidth = iconShapeElement.width() || parseInt(iconShapeElement[0].style.width, 10);

			switch (shapeType) {
				case "Line":
					stroke = (stroke > 0 ? stroke : 1);
					if (iconShapeWidth >= iconShapeHeight) {
						shapeSize = {
							x1: 0,
							y1: iconShapeHeight / 2 - (stroke % 2 ? 0 : 0.5),
							x2: iconShapeWidth,
							y2: iconShapeHeight / 2 - (stroke % 2 ? 0 : 0.5)
						};
					} else {
						shapeSize = {
							x1: iconShapeWidth / 2,
							y1: 0,
							x2: iconShapeWidth / 2,
							y2: iconShapeHeight
						};
					}
					shapeSize["stroke-width"] = stroke;
					break;
				case "Rectangle":
					shapeSize = {
						x: stroke / 2,
						y: stroke / 2,
						width: iconShapeWidth - stroke,
						height: iconShapeHeight - stroke
					};
					break;
				case "Rounded":
					shapeSize = {
						x: stroke / 2,
						y: stroke / 2,
						width: iconShapeWidth - stroke,
						height: iconShapeHeight - stroke
					};
					break;
				case "Circle":
					radius = Math.min(iconShapeWidth, iconShapeHeight) / 2;
					shapeSize = {
						cx: radius + ((iconShapeWidth - radius * 2) / 2),
						cy: radius + ((iconShapeHeight - radius * 2) / 2),
						r: radius - stroke / 2
					};
					break;
				case "Ellipse":
					shapeSize = {
						cx: iconShapeWidth / 2,
						cy: iconShapeHeight / 2,
						rx: iconShapeWidth / 2 - stroke / 2,
						ry: iconShapeHeight / 2 - stroke / 2
					};
					break;
				case "Triangle":
					shapeSize = {
						points: "0," + (iconShapeHeight - stroke / 2) + " " +
								(iconShapeWidth / 2) + "," + (stroke / 2) + " " +
								(iconShapeWidth) + "," + (iconShapeHeight - stroke / 2)
					};
					break;
				case "Polygon":
					sides = polygonSides || 6;
					radius = Math.min(iconShapeWidth - stroke, iconShapeHeight - stroke) / 2;
					shapeSize = {
						points: this.calculatePolygonPoints(sides, radius, iconShapeWidth / 2, iconShapeHeight / 2)
					};
					break;
				default:
					shapeSize = null;
					break;
			}

			return shapeSize;
		},

		calculatePolygonPoints: function(sides, radius, centerX, centerY) {
			var myPoints	= [];
			var polyXPts	= Array(sides);
			var polyYPts	= Array(sides);
			var vertexAngle	= 360/sides;
			var theAngle;

			for (var v=0; v < sides; v++) {
				theAngle = ((v * vertexAngle) + 90) * Math.PI/180;
				polyXPts[v] = radius * Math.cos(theAngle);
				polyYPts[v] = -radius * Math.sin(theAngle);
			}
	
			for (var z=0; z < sides; z++) {
				var point = [centerX + polyXPts[z], centerY + polyYPts[z]];
				myPoints.push(point);
			}

			return myPoints.join(" ");
		},

		setSelectedIcon: function (iconId, iconContainer) {
			var categoryPrefix = iconId.split("-")[0] + "-";
			var use;

			// clear selection
			if ($("#is_library .iconSelect.selected").length > 0)
				$("#is_library .iconSelect.selected").get(0).setAttribute("class", "iconSelect");

			// find icon (when iconShape settings control is opened we need to select correct one)
			if (!iconContainer) {
				$("#ddliconFilterCategories").val(categoryPrefix).trigger("change");
				$('#iconsSelector').focus();
				var iconSvgs = document.getElementById("iconsSelector").getElementsByClassName("iconSelect");
				for (var i = 0; i < iconSvgs.length; i++) {
					use = iconSvgs[i].firstChild;
					if (use.getAttributeNS(xlinkNS, "href").substr(1) == iconId) {
						iconContainer = iconSvgs[i];
						IconShapeUI.scrollToIconMiddle(iconContainer);
						break;
					}
				}
			}

			if (iconContainer)
				iconContainer.setAttribute("class", "iconSelect selected");

			var iconInfo = IconShapeUI.getIconInfo(iconId);

			$("#IconShapeTitle").text(categoryPrefix !== "character-" ? iconInfo.title : "");
			$("#IconShapeTags").text(categoryPrefix !== "character-" ? iconInfo.tags : "");

			$("#hidIconShapeType").val(1);
			$("#hidIconShapeKey").val(iconId);
			IconShapeUI.cloneIcon(iconId, categoryPrefix);
			IconShapeUI.onIconChanged(categoryPrefix);
		},

		scrollToIconMiddle: function(iconEl) {
			var iconsSelector = document.getElementById("iconsSelector");

			iconsSelector.scrollTop = 0;

			var iconElPos = iconEl.getBoundingClientRect();
			var iconsSelectorPos = iconsSelector.getBoundingClientRect();

			// scroll list to selected icon
			iconsSelector.scrollTop = (iconElPos.top - iconsSelectorPos.top) - 
									(iconsSelectorPos.height / 2) + 
									(iconElPos.height / 2);
		},

		scrollToIconTop: function(iconEl, direction) {
			var iconsSelector = document.getElementById("iconsSelector");
			var iconElPos = iconEl.getBoundingClientRect();
			var iconsSelectorPos = iconsSelector.getBoundingClientRect();

			if (iconElPos.top < iconsSelectorPos.top || 
				iconElPos.top > iconsSelectorPos.top + iconsSelectorPos.height - iconElPos.height)
					iconsSelector.scrollTop = iconElPos.top - iconsSelectorPos.top + iconsSelector.scrollTop - 1;
		},

		cloneIcon: function (iconId, categoryPrefix) {
			var iconSource = document.getElementById(iconId);
			if (typeof iconSource !== "undefined" && iconSource !== null) {
				var iconElement = iconSource.lastElementChild.cloneNode(true);
				var viewBox = iconSource.getAttribute("viewBox");
				var iconSvgElement = document.createElementNS(svgNS, "svg");
				var groupStylesElement = document.createElementNS(svgNS, "g");

				this.clearPreview();

				iconSvgElement.setAttribute("viewBox", viewBox);
				iconSvgElement.setAttribute("preserveAspectRatio", "xMidYMid");
				groupStylesElement.setAttribute("class", "group-styles");

				if (categoryPrefix === "flag-")
					iconElement.setAttribute("class", "image-flag image-flag-" + iconId);
				else
					iconElement.setAttribute("class", "path-icon path-icon-" + iconId);

				iconSvgElement.appendChild(iconElement);
				groupStylesElement.appendChild(iconSvgElement);
				previewSvgEl.appendChild(groupStylesElement);

				previewStylesGroupEl = groupStylesElement;
				previewIconSvgEl = iconSvgElement;
				previewIconEl = iconElement;
			}
		},

		filterIcons: function () {
			var keywords = $("#txtIconSearch").val().toLowerCase();
			var categoryPrefix = $("#ddliconFilterCategories").val();
			var category = IconShapeUI.getCategoryByPrefix(categoryPrefix);
			var i;

			if (category && typeof category.loaded === "undefined") {
				IconShapeUI.loadIcons(category);
				return;
			}

			var iconSelector = document.getElementById("iconsSelector");
			var svgUse = iconSelector.getElementsByTagName("use");
			var svgSymbols = iconSelector.getElementsByTagName("symbol");
			
			svgSymbols = $.grep(svgSymbols, function(s) { return s.id.indexOf(categoryPrefix) === 0; });

			var searchKeywords = keywords.replace(/, /g, " ").replace(/s\b/g, "").replace(/\s+/g, " ").trim().replace(/ /g, "|");
			var searchRegExp = new RegExp(searchKeywords, "i");
			var searchResults = [], desc;

			for (i = 0; i < svgSymbols.length; i++) {
				if (keywords) {
					desc = svgSymbols[i].querySelector("desc");
					if (desc && desc.textContent.search(searchRegExp) > -1) {
						searchResults.push(svgSymbols[i].id);
					}
				} else searchResults.push(svgSymbols[i].id);
			}

			for (i = 0; i < svgUse.length; i++) {
				if (searchResults.indexOf(svgUse[i].getAttributeNS(xlinkNS, "href").substr(1)) > -1)
					svgUse[i].parentNode.style.display = "";
				else
					svgUse[i].parentNode.style.display = "none";
			}

			setTimeout(IconShapeUI.filterTags, 500);
		},

		filterTags: function () {
			var keyword = $("#txtIconSearch").val().toLowerCase();

			$("#IconShapeTagsList").css("display", "none").empty();

			if ($("#txtIconSearch").is(":focus") && keyword !== "" && keyword.indexOf(" ") === -1) {
				
				var categoryPrefix = $("#ddliconFilterCategories").val();
				var category = IconShapeUI.getCategoryByPrefix(categoryPrefix);
				var tags;

				if (category.tags) {
					tags = category.tags.filter(function(value, index, arr) {
						return (keyword.length === 1 ? value.toLowerCase().indexOf(keyword) === 0 : value.toLowerCase().indexOf(keyword) > -1);
					});
				}
			
				if (tags.length > 1 || (tags.length === 1 && tags[0] !== keyword)) {
					$('#IconShapeTagsList').append("<span>"+ tags.join("</span><span>") + "</span>").css("display", "block");
				}
			}
		},

		getIconInfo: function(iconId) {
			var iconInfo = {},
				icon = document.getElementById(iconId),
				titleEl, descEl;
			
			if (icon) {
				titleEl = icon.querySelector("title");
				descEl = icon.querySelector("desc");
				iconInfo.title = (titleEl ? titleEl.textContent : "");
				iconInfo.tags = (descEl ? descEl.textContent : "");
			}

			return iconInfo;
		},

		getColorObject: function() {
			var colorObject = {};
			
			colorObject.color = $("#si_style_color").DUIColorPicker("get.selectedColor");
			colorObject.colorId = $("#si_style_color").DUIColorPicker("get.selectedColorId");
			
			return colorObject;
		},

		getStrokeObject: function() {
			var strokeObject = {};
			
			strokeObject.color = $("#si_style_stroke").DUIColorPicker("get.selectedColor");
			strokeObject.colorId = $("#si_style_stroke").DUIColorPicker("get.selectedColorId");
			
			return strokeObject;
		},

		getGradientObject: function () {
			var gradientObject = { stops: [{}, {}], orientation: "" };
			var color1 = $("#si_style_gradient_stop_1_stop-color").DUIColorPicker('get.selectedColor');
			var color2 = $("#si_style_gradient_stop_2_stop-color").DUIColorPicker('get.selectedColor');
			var color1Id = $("#si_style_gradient_stop_1_stop-color").DUIColorPicker('get.selectedColorId');
			var color2Id = $("#si_style_gradient_stop_2_stop-color").DUIColorPicker('get.selectedColorId');

			if (color1.indexOf("transparent") > -1 || color1.replace(/ /g, "").indexOf("(255,255,255,0") > -1) {
				gradientObject.stops[0]["stop-opacity"] = 0;
				color1 = "white";
			}
			if (color2.indexOf("transparent") > -1 || color2.replace(/ /g, "").indexOf("(255,255,255,0") > -1) {
				gradientObject.stops[1]["stop-opacity"] = 0;
				color2 = "white";
			}

			gradientObject.stops[0]["offset"] = $("#si_style_gradient_stop_1_offset").val() + "%";
			gradientObject.stops[0]["stop-color"] = color1;
			gradientObject.stops[1]["offset"] = $("#si_style_gradient_stop_2_offset").val() + "%";
			gradientObject.stops[1]["stop-color"] = color2;
			gradientObject.orientation = $("#si_style_gradient_orientation").val();

			if (color1Id) gradientObject.stops[0]["data-stop-color-colorplaceholderid"] = color1Id;
			if (color2Id) gradientObject.stops[1]["data-stop-color-colorplaceholderid"] = color2Id;

			return gradientObject;
		},

		getFlipArray: function () {
			var flipArray = [];
			flipArray[0] = ($("#si_style_flip_horizontal").is(":checked") ? true : false);
			flipArray[1] = ($("#si_style_flip_vertical").is(":checked") ? true : false);
			return flipArray;
		},

		getStrokeWidth: function () {
			var strokeWidth = parseInt($("#si_style_stroke_width").val(), 10);
			return strokeWidth || 0;
		},

		getPolygonSides: function () {
			var polygonSides = parseInt($("#si_style_polygon_sides").val(), 10);
			return polygonSides || 6;
		},

		clearPreview: function (removeEvents) {
			if (removeEvents) IconShapeUI.EventsManager.removeEventsFromSvgElement(previewSvgEl);
			this.clearElement(previewSvgEl);
			previewShapeEl = null;
			previewIconSvgEl = null;
			previewIconEl = null;
		},

		clearElement: function (element) {
			if (element) {
				while (element.lastChild) {
					element.removeChild(element.lastChild);
				}
			}
		},

		setColor: function (colorObject, element) {
			var color = colorObject.color;
			var colorId = colorObject.colorId;

			if (color.indexOf("transparent") > -1 ||
				color.replace(/ /g, "").indexOf("(255,255,255,0") > -1) {
					element.setAttribute("fill-opacity", 0.01);
			} else {
				element.removeAttribute("fill-opacity");
			}

			if (colorId) {
				element.setAttribute('data-fill-colorplaceholderid', colorId);
			} else {
				element.removeAttribute('data-fill-colorplaceholderid');
			}

			element.setAttribute("fill", color);
		},

		setGradient: function (gradientObject, element, svgElement, guid) {
			var defs = svgElement.querySelector("defs") || 
				svgElement.insertBefore(document.createElementNS(svgNS, "defs"), svgElement.firstChild);
			var gradient = document.createElementNS(svgNS, "linearGradient");
			var gradientGuid = "gradient-" + guid;

			if (gradientObject.orientation === "horizontal" || gradientObject.orientation === "vertical") {
				gradient = document.createElementNS(svgNS, "linearGradient");

				gradient.setAttribute("id", gradientGuid);
				gradient.setAttribute("x1", "0%");
				gradient.setAttribute("y1", "100%");
				gradient.setAttribute("x2", (gradientObject.orientation === "horizontal" ? "100%" : "0%"));
				gradient.setAttribute("y2", (gradientObject.orientation === "vertical" ? "0%" : "100%"));
			}

			if (gradientObject.orientation === "radial") {
				gradient = document.createElementNS(svgNS, "radialGradient");

				gradient.setAttribute("id", gradientGuid);
				gradient.setAttribute("cx", "50%");
				gradient.setAttribute("cy", "50%");
				gradient.setAttribute("r", "50%");
				gradient.setAttribute("fx", "50%");
				gradient.setAttribute("fy", "50%");
			}

			for (var i = 0; i < gradientObject.stops.length ; i++) {
				var attrs = gradientObject.stops[i];
				var stop = document.createElementNS(svgNS, "stop");

				for (var attr in attrs) {
					if (attrs.hasOwnProperty(attr)) stop.setAttribute(attr, attrs[attr]);
				}

				gradient.appendChild(stop);
			}

			var oldGradient = defs.querySelector("linearGradient") || defs.querySelector("radialGradient");
			if (oldGradient) oldGradient.parentNode.removeChild(oldGradient);

			defs.appendChild(gradient);
			element.setAttribute("fill", "url(#" + gradientGuid + ")");
		},

		setInvert: function (invert, iconSvgElement, gElement, svgElement, guid) {
			var maskGuid = "mask-" + guid;
			var mask, maskGroup, maskRectangle;
			var rotationGroup = svgElement.querySelector(".group-rotation");

			if (invert === true) { // set mask
				var defs = svgElement.querySelector("defs") || 
					svgElement.insertBefore(document.createElementNS(svgNS, "defs"), svgElement.firstChild);

				// Create mask elements
				mask = document.createElementNS(svgNS, "mask");
				maskGroup = document.createElementNS(svgNS, "g");
				maskRectangle = document.createElementNS(svgNS, "rect");
				mask.setAttribute("id", maskGuid);
				maskGroup.setAttribute("class", "group-mask");
				this.setShapeAttributes(maskRectangle, {
					x: 0,
					y: 0,
					width: "100%",
					height: "100%",
					fill: "#ffffff"
				});
				iconSvgElement.querySelector(".path-icon").setAttribute("fill", "#000000");
				maskGroup.appendChild(maskRectangle);
				
				if (rotationGroup) 
					maskGroup.appendChild(rotationGroup);
				else
					maskGroup.appendChild(iconSvgElement);

				mask.appendChild(maskGroup);
				var oldMask = svgElement.querySelector("#" + maskGuid);
				if (oldMask) oldMask.parentNode.removeChild(oldMask);
				defs.appendChild(mask);

				// Create Rectangle element to hold mask
				var elementRectangle = document.createElementNS(svgNS, "rect");
				this.setShapeAttributes(elementRectangle, {
					x: 0,
					y: 0,
					width: "100%",
					height: "100%",
					mask: "url(#" + maskGuid + ")"
				});

				gElement.appendChild(elementRectangle);

			} else { // remove mask
				mask = svgElement.querySelector("#" + maskGuid);
				if (mask) {
					this.clearElement(gElement);
					iconSvgElement.querySelector(".path-icon").removeAttribute("fill");
					
					if (rotationGroup) 
						gElement.appendChild(rotationGroup);
					else
						gElement.appendChild(iconSvgElement);

					mask.parentNode.removeChild(mask);
				}
			}
		},

		setFlip: function (flipArray, svgElement) {
			var flipGroup = svgElement.querySelector(".group-flip");
			var viewBox, hScale, vScale, hTranslate, vTranslate, attrValue;

			if (flipArray[0] === false && flipArray[1] === false) {
				if (flipGroup) {
					svgElement.appendChild(flipGroup.querySelector(".path-icon"));
					flipGroup.parentNode.removeChild(flipGroup);
				}
			} else {
				if (flipGroup === null) {
					flipGroup = document.createElementNS(svgNS, "g");
					flipGroup.setAttribute("class", "group-flip");
					flipGroup.appendChild(svgElement.querySelector(".path-icon"));
					svgElement.appendChild(flipGroup);
				}
				viewBox = svgElement.getAttributeNS(null, "viewBox").split(/\s+|,/);
				hScale = (flipArray[0] === true ? -1 : 1);
				vScale = (flipArray[1] === true ? -1 : 1);
				hTranslate = (flipArray[0] === true ? -viewBox[2] : 0);
				vTranslate = (flipArray[1] === true ? -viewBox[3] : 0);
				attrValue = "scale(" + hScale + ", " + vScale + ") translate(" + hTranslate + ", " + vTranslate + ")";
				if (flipGroup)
					flipGroup.setAttribute("transform", attrValue);
			}
		},

		setPadding: function (padding, iconShapeElement) {
			iconShapeElement = $(iconShapeElement) || previewElement;
			padding = parseInt(padding, 10);

			var svgElement = iconShapeElement[0].querySelector("svg svg");
			var iconPath;

			if (svgElement)
				iconPath = svgElement.querySelector(".path-icon");

			var w = parseInt(iconShapeElement.width(), 10);
			var h = parseInt(iconShapeElement.height(), 10);

			if (isNaN(padding) || padding > 49 || !iconPath)
				return;

			if (padding === 0) {
				iconPath.setAttribute("transform", "");
				return;
			}

			var scale, translate;
			var viewBox = svgElement.getAttributeNS(null, "viewBox").split(/\s+|,/);
			var iconW = parseInt(viewBox[2], 10);
			var iconH = parseInt(viewBox[3], 10);

			scale = 1 - (padding * 2 / 100);

			translate = (((w / 2) - ((iconW * scale) / 2) - ((w - iconW) / 2)) * (1 / scale)) +
						"," +
						(((h / 2) - ((iconH * scale) / 2) - ((h - iconH) / 2)) * (1 / scale));

			iconPath.setAttribute("transform", "scale(" + scale + ") translate(" + translate + ")");
		},

		setOpacity: function (opacity, element) {
			opacity = parseInt(opacity, 10);

			if (isNaN(opacity) || opacity >= 100) {
				opacity = 100;
				element.removeAttribute("opacity");
			} else if (opacity <= 0) {
				opacity = 0;
				element.setAttribute("opacity", 0);
			} else {
				element.setAttribute("opacity", opacity / 100);
			}

			return opacity;
		},

		setRotate: function (rotateDeg, iconShapeElement) {
			iconShapeElement = iconShapeElement || previewElement;
			rotateDeg = parseInt(rotateDeg, 10);

			var svgElement = iconShapeElement[0].querySelector("svg"),
				boundariesInner, boundariesRotated, scale, rotateString, scaleString, translateString, x, y, w, h,
				groupStylesElement, groupMaskElement, groupRotationElement, pathIcon, child, rotatedElement, shapeType;

			if (svgElement) {
				groupStylesElement		= svgElement.querySelector(".group-styles");
				groupMaskElement		= svgElement.querySelector(".group-mask");
				groupRotationElement	= svgElement.querySelector(".group-rotation");
				pathIcon				= svgElement.querySelector(".path-icon");
				rotatedElement			= pathIcon || 
											svgElement.querySelector(".element-shape") || 
											svgElement.querySelector(".image-flag");
			}

			if (pathIcon === null && svgElement.querySelector(".element-shape") !== null) {
				shapeType = rotatedElement.getAttribute("class").split("-shape-")[1];
			}

			// Remove rotation
			if (isNaN(rotateDeg) || rotateDeg === 0) {
				if (!groupRotationElement) return;

				child = groupRotationElement.firstChild;
				while (child !== null) {
					groupRotationElement.parentNode.appendChild(child);
					child = child.nextSibling;
				}
				groupRotationElement.parentNode.removeChild(groupRotationElement);

				return;
			}

			// Create rotation group
			if (!groupRotationElement && !isNaN(rotateDeg) && rotateDeg !== 0) {
				groupRotationElement = document.createElementNS(svgNS, "g");
				groupRotationElement.setAttribute("class", "group-rotation");
				
				if (groupMaskElement) {
					groupRotationElement.appendChild(groupMaskElement.querySelector("svg"));
					groupMaskElement.appendChild(groupRotationElement);
				} else {
					child = groupStylesElement.firstChild;
					while (child !== null) {
						groupRotationElement.appendChild(child);
						child = child.nextSibling;
					}
					groupStylesElement.appendChild(groupRotationElement);
				}	
			}

			// Set rotation

			w = parseInt(iconShapeElement.width() | 0, 10);
			h = parseInt(iconShapeElement.height() | 0, 10);

			rotateString = "rotate(" + rotateDeg + " " + w / 2 + " " + h / 2 + ")";
			groupRotationElement.setAttribute("transform", rotateString);

			if (shapeType && (shapeType === "Circle" || shapeType === "Polygon"))
				return;

			var getInnerBoundingBox = function(w, h, pathIcon) {
				var innerW, innerH;

				if (pathIcon) {
					var viewBox = svgElement.querySelector("svg").getAttribute("viewBox").split(/\s+|,/);
					innerW = viewBox[2];
					innerH = viewBox[3];
				} else {
					innerW = rotatedElement.getAttribute("width") || w;
					innerH = rotatedElement.getAttribute("height") || h;
				}

				if ((w / h) > (innerW / innerH)) {
					innerW = (h * innerW) / innerH;
					innerH = h;
				} else {
					innerH = (w * innerH) / innerW;
					innerW = w;
				}

				return { width: innerW, height: innerH };
			};

			var getRotatedBoundingBox = function(w, h, rads){
				var c = Math.abs(Math.cos(rads));
				var s = Math.abs(Math.sin(rads));
				return({  width: h * s + w * c,  height: h * c + w * s });
			};

			boundariesInner = getInnerBoundingBox(w, h, pathIcon);
			boundariesRotated = getRotatedBoundingBox(boundariesInner.width, boundariesInner.height, rotateDeg * Math.PI / 180);

			scale = Math.min(w / boundariesRotated.width, h / boundariesRotated.height);
			scaleString = rotateString + " scale("+ scale +")";

			x = ((w - (w / (1 / scale))) / 2) * (1 / scale);
			y = ((h - (h / (1 / scale))) / 2) * (1 / scale);
			
			translateString = scaleString + " translate("+ x + " "+ y +")";

			groupRotationElement.setAttribute("transform", translateString);
		},

		setStroke: function (colorObject, element) {
			var color = colorObject.color;
			var colorId = colorObject.colorId;

			if (colorId) {
				element.setAttribute('data-stroke-colorplaceholderid', colorId);
			} else {
				element.removeAttribute('data-stroke-colorplaceholderid');
			}

			element.setAttribute("stroke", color);
		},

		setStrokeDashArray: function (dashArray, element) {
			var stroke = element.getAttribute("stroke-width");
			dashArray = dashArray.split(",");

			if (dashArray == "0") {
				element.removeAttribute("stroke-dasharray");
				return;
			}

			for (var i = dashArray.length - 1; i >= 0; i--) {
				dashArray[i] = parseInt(dashArray[i], 10) * stroke;
			}

			element.setAttribute("stroke-dasharray", dashArray.join(","));
		},

		setRadius: function (radius, element) {
			var radiusAttributes = { rx: radius, ry: radius };
			this.setShapeAttributes(element, radiusAttributes);
		},

		setShapeAttributes: function (element, shapeAttributes) {
			for (var attr in shapeAttributes) {
				if (typeof attr === "string"
					&& shapeAttributes[attr] !== undefined
					&& shapeAttributes[attr] !== null)
					element.setAttribute(attr, shapeAttributes[attr]);
			}
		},
		
		renderLine: function (x1, y1, x2, y2, stroke, strokeWidth) {
			var attr = typeof x1 === "object" ? x1 : {
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2
			};
			var newLine = document.createElementNS(svgNS, "line");

			this.setShapeAttributes(newLine, attr);

			return newLine;
		},
		renderRectangle: function (x, y, width, height) {
			var attr = typeof x === "object" ? x : { x: x, y: y, width: width, height: height };
			var newRectangle = document.createElementNS(svgNS, "rect");
			this.setShapeAttributes(newRectangle, attr);
			return newRectangle;
		},
		renderRounded: function (x, y, width, height, rx, ry) {
			var attr = typeof x === "object" ? x : { x: x, y: y, width: width, height: height, rx: rx, ry: ry };
			var newRounded = document.createElementNS(svgNS, "rect");
			this.setShapeAttributes(newRounded, attr);
			return newRounded;
		},
		renderCircle: function (cx, cy, r) {
			var x;
			var y;
			var attr = typeof cx === "object" ? cx : { x: x, y: y, r: r };
			var newCircle = document.createElementNS(svgNS, "circle");
			this.setShapeAttributes(newCircle, attr);
			return newCircle;
		},
		renderEllipse: function (cx, cy, rx, ry) {
			var attr = typeof cx === "object" ? cx : { cx: cx, cy: cy, rx: rx, ry: ry };
			var newEllipse = document.createElementNS(svgNS, "ellipse");
			this.setShapeAttributes(newEllipse, attr);
			return newEllipse;
		},
		renderPolygon: function (points) {
			var newPolygon = document.createElementNS(svgNS, "polygon");
			this.setShapeAttributes(newPolygon, points);
			return newPolygon;
		},
		renderTriangle: function (points) {
			return this.renderPolygon(points);
		}
	};
}();
